import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./CKYCVerificationSuccess.module.scss";

export default function CKYCVerificationSuccess() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [storedName, setStoredName] = useState("");
  const [storedCkycId, setStoredCkycId] = useState("");

  useEffect(() => {
    setStoredName(localStorage.getItem("ckyc_fullname") || "");
    setStoredCkycId(localStorage.getItem("ckyc_ckycReferenceId") || "");
  }, []);

  return (
    <div className={`${styles.wrapper} auto-height`}>
      {/* Header */}
      <div className={styles.header}>
        <h1>CKYC Verification</h1>

        <p>We will securely retrieve your CKYC record from CERSAI and auto-fill your details.</p>
      </div>

      {/* Success Content */}
      <div className={styles.content}>
        {/* Success Image */}
        <div className={styles.successImage}>
          <img src="/images/verified.png" alt="Verification Successful" />
        </div>

        {/* Title */}
        <h2>Verification Successful</h2>

        {/* Description */}
        <p className={styles.description}>Your CKYC record has been successfully verified. We've auto-filled your details in the application.</p>

        {/* CKYC Details Card */}
        <div className={styles.detailsCard}>
          {/* Name */}
          <div>
            <p className={styles.label}>Name</p>
            <p className={styles.value}>{state?.fullName || storedName}</p>
          </div>

          {/* CKYC ID */}
          <div className={styles.ckycId}>
            <p className={styles.label}>CKYC ID</p>
            <p className={styles.value}>{state?.ckycReferenceId || storedCkycId}</p>
          </div>
        </div>
      </div>

      {/* Bottom Actions */}
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.continueButton}
          onClick={() => {
            localStorage.removeItem("ckyc_fullname");
            localStorage.removeItem("ckyc_ckycReferenceId");
            navigate("/loan-approval");
          }}
        >
          Continue
        </button>

        {/* Security Message */}
        <div className={styles.security}>
          <span>🔒</span>
          <span>Your information is secure and encrypted</span>
        </div>
      </div>
    </div>
  );
}
